import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SwiperModule } from 'swiper/angular';

import { DotCmsUveCategoryCardComponent } from '../dot-cms-uve-category-card/dot-cms-uve-category-card.component';
import { DotCmsDynamicCategories } from '../dot-cms-uve-category-tile/dot-cms-uve-category-tile.component';

@Component({
  selector: 'custom-dot-cms-uve--category-swiper',
  templateUrl: './dot-cms-uve-category-swiper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SwiperModule, DotCmsUveCategoryCardComponent],
})
export class DotCmsUveCategorySwiperComponent {
  readonly dynamicCategory = input<DotCmsDynamicCategories>(undefined);
}
